import { gql } from "@apollo/client";

export const GET_SHARED_CLIENT_ACCOUNT = gql`
  query SharedClientAccount($token: String!) {
    sharedClientAccount(token: $token) {
      id
      firstName
      lastName
      fullName
      dateJoined
    }
  }
`;

export const GET_SHARED_FAVORITE_BUSINESSES = gql`
  query SharedFavoriteBusinesses($token: String!, $first: Int, $after: String) {
    sharedFavoriteBusinesses(token: $token, first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
          slug
          about
          logoUrl
          headerImageUrl
          bookingUrlIdentifier
          countryCode
          timezone
          acceptsOnlineBookings
          businessSpecialties {
            id
            name
          }
          salons(bookingVisible: true) {
            id
            city
            state
          }
        }
      }
    }
  }
`;
